import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = [{
    title: 'Africa-First Expertise',
    description: 'Deep understanding of African enterprise needs, regulatory environments, and market dynamics.'
  }, {
    title: 'Certified Partnerships',
    description: 'Official partner of SentientLogics AI powered by Prisma AI, bringing global standards to local deployments.'
  }, {
    title: 'Proven Results',
    description: 'Measurable ROI across 50+ enterprise deployments with a focus on tangible business outcomes.'
  }, {
    title: 'End-to-End Delivery',
    description: 'Comprehensive support from initial strategy to deployment, training, and ongoing optimization.'
  }];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-208">
      {/* Background Glow */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[500px] h-[500px] bg-brand-primary/10 blur-[120px] rounded-full pointer-events-none" data-id="element-209"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-210">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-211">
          {/* Left Text */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-212">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-213">
              <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-214"></div>
              <h2 className="text-brand-primary font-semibold uppercase tracking-wider text-sm" data-id="element-215">
                Why Choose SpringLinks
              </h2>
            </div>

            <h3 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-216">
              The Strategic Advantage for Modern Enterprises
            </h3>

            <p className="text-gray-400 text-lg leading-relaxed mb-8" data-id="element-217">
              We bridge the gap between cutting-edge artificial intelligence and
              practical business application. Our approach ensures that AI
              adoption isn't just a technological upgrade, but a fundamental
              driver of efficiency, innovation, and growth for your
              organization.
            </p>

            <div className="flex items-center gap-4" data-id="element-218">
              <div className="w-16 h-16 rounded-full bg-brand-primary/20 flex items-center justify-center border border-brand-primary/30 pulse-glow" data-id="element-219">
                <span className="text-brand-light font-bold text-xl" data-id="element-220">1st</span>
              </div>
              <p className="text-white font-medium" data-id="element-221">
                Kenya's Premier AI-First
                <br data-id="element-222" />
                Enterprise Solutions Provider
              </p>
            </div>
          </motion.div>

          {/* Right List */}
          <div className="space-y-6" data-id="element-223">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} className="glass-card p-6 rounded-2xl flex gap-4 hover:bg-white/10 transition-colors duration-300" data-id="element-224">
                <div className="flex-shrink-0 mt-1" data-id="element-225">
                  <CheckCircleIcon className="w-6 h-6 text-brand-primary" data-id="element-226" />
                </div>
                <div data-id="element-227">
                  <h4 className="text-xl font-bold text-white mb-2" data-id="element-228">
                    {reason.title}
                  </h4>
                  <p className="text-gray-400 leading-relaxed" data-id="element-229">
                    {reason.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}